/**
 * Labels + Badge-Styles fuer das UNTERSUCHUNGSSTATUS-Enum (BC.Status, Vorsorge).
 */

import type { UntersuchungStatus } from "@/types"

export const EXAMINATION_STATUS: Record<
  UntersuchungStatus,
  { label: string; badge: string }
> = {
  AUSSTEHEND: {
    label: "Ausstehend",
    badge: "border-yellow-300 bg-yellow-100 text-yellow-800",
  },
  GEPLANT: {
    label: "Geplant",
    badge: "border-blue-300 bg-blue-100 text-blue-800",
  },
  DURCHGEFUEHRT: {
    label: "Durchgeführt",
    badge: "border-green-300 bg-green-100 text-green-800",
  },
  ERLEDIGT: {
    label: "Erledigt",
    badge: "border-green-300 bg-green-100 text-green-800",
  },
}

export const EXAMINATION_STATUS_VALUES = Object.keys(
  EXAMINATION_STATUS
) as UntersuchungStatus[]
